import { PROFILE_PATHS } from '../auth/profile.ts'
import type { NavigationEntry } from './entries.ts'
import { NAV_PATHS } from './paths.ts'

// What a thumb reaches first. The desktop column keeps the menu's own order.
const BAR_PRIORITY: readonly string[] = [
  NAV_PATHS.teams,
  NAV_PATHS.matches,
  NAV_PATHS.officialPlayers,
  NAV_PATHS.leagues,
  NAV_PATHS.officialRequests,
  NAV_PATHS.officialPeople,
  NAV_PATHS.officialPitches,
  NAV_PATHS.subscriptions,
  ...PROFILE_PATHS,
]

function priorityOf(entry: NavigationEntry): number {
  const index = BAR_PRIORITY.indexOf(entry.path)
  return index === -1 ? BAR_PRIORITY.length : index
}

// The first profile held, in the precedence `/` routes by: the one place that states it.
function homeOf(entries: readonly NavigationEntry[]): NavigationEntry | undefined {
  for (const path of PROFILE_PATHS) {
    const entry = entries.find((candidate) => candidate.path === path)
    if (entry !== undefined) return entry
  }
  return entries[0]
}

export interface BarNavigation {
  readonly home: NavigationEntry
  readonly others: readonly NavigationEntry[]
}

/** The bottom bar's reading of the menu. `null` when there is nothing to navigate. */
export function barNavigation(entries: readonly NavigationEntry[]): BarNavigation | null {
  const home = homeOf(entries)
  if (home === undefined) return null
  const others = entries
    .filter((entry) => entry !== home)
    .toSorted((a, b) => priorityOf(a) - priorityOf(b))
  return { home, others }
}
